import React from 'react';
import FlexionChart from './FlexionChart';

export default function HipFlexionChart({ timeSeriesData, height = "400px" }) {
  if (!timeSeriesData || timeSeriesData.length === 0) {
    return null; // Don't render anything if no data
  }

  return (
    <FlexionChart
      title="Hip Flexion Analysis (Normalized)"
      timeSeriesData={timeSeriesData}
      leftDataKey="left_hip_flexion_norm"
      rightDataKey="right_hip_flexion_norm"
      height={height}
      yAxisLabel="Hip Flexion (degrees)"
      leftColor="#388E3C"
      rightColor="#D32F2F"
    />
  );
}
